import React from 'react';
import { Link } from 'react-router-dom';
import Users from '../users/Users';

class Sidebar extends React.Component {

	constructor(props) {
  	super(props)

		this.state = {
			profile: {},
			adminGlobalAccessLevel: 99,
			isAuthenticated: false,
			charterAdmin: ''
		};
	}

  componentDidMount() {
    //console.log('Sidebar: componentDidMount');
    //console.log(this.props);
    
    //this.props.auth.on('profile_updated', (newProfile) => {
    // 	this.updateProfile(newProfile);
    //});

		this.updateProfile(this.props.auth.getProfile());
	}

	UNSAFE_componentWillReceiveProps(nextprops) {
    //console.log('Sidebar: UNSAFE_componentWillReceiveProps');
    //console.log(nextprops);
		this.updateProfile(nextprops.auth.getProfile());
	}

  updateProfile(profile) {
    //console.log('Sidebar: updateProfile');
    var isAuthenticated = this.props.auth.isAuthenticated();

    // console.log(accessToken);
    // console.log(profile);
    // console.log(isAuthenticated);

    var adminGlobalAccessLevel = 99;

    // Get admin access
    // console.log('profile before getAccess');
    // console.log(isAuthenticated);
    // console.log(profile);

    var _this = this;
    if (isAuthenticated) {
    	//console.log('Sidebar: updateProfile');
    	//console.log(profile);
    	Users.getAccessLevel(profile, function(adminGlobalAccessLevel) {
			Users.getCharterAdmin(profile, function(charterAdmin) {

				console.log('AUTHENTICATED');
          _this.setState({
            isAuthenticated: isAuthenticated,
            profile: profile,
            adminGlobalAccessLevel: adminGlobalAccessLevel,
            charterAdmin: charterAdmin
          });
   		});
   		});
		} else {
			console.log('DISCONNECTED');
    	_this.setState({
        isAuthenticated: isAuthenticated,
        profile: null,
        adminGlobalAccessLevel: 99,
        charterAdmin: ''
  	  });
		}
  }

	handleClick(e) {
		e.preventDefault();
		e.target.parentElement.classList.toggle('open');
	}

	// Found that magic trick! (in header.js)
	sidebarClick(e) {
		document.body.classList.toggle('sidebar-mobile-show');
	}

	connect() {
		this.props.auth.login();
	}

	disconnect() {
		this.props.auth.logout();
    this.updateProfile(this.props.auth.getProfile());
		this.props.history.push('/');
	}

	render() {
		return (
			<div className="sidebar no-print row-margin-bottom-200">
			<nav className="sidebar-nav">
				<ul className="nav" onClick={this.sidebarClick}>
					<li className="nav-title text-center">
						<span>STATELO</span>
					</li>
					<li className="nav-item">
						<Link to='/home' className="nav-link">
							<i className="icon-home"></i> Accueil
						</Link>
					</li>
					<li className="nav-item">
						<Link to='/stats' className="nav-link">
							<i className="icon-trophy"></i> Statistiques
						</Link>
					</li>
					<li className="nav-item">
						<Link to='/players' className="nav-link">
							<i className="icon-people"></i> Joueurs
						</Link>
					</li>
					<li className="nav-title text-center">
						<span>TABLEAU DE BORD</span>
					</li>
					<li className="nav-item">
						<Link to='/tableau-de-bord' className="nav-link">
							<i className="icon-bulb"></i> Aperçu général
						</Link>
						<Link to='/playerDashboard' className="nav-link">
							<i className="icon-speedometer"></i> Mon Tableau de Bord
						</Link>
					</li>


					<li className="nav-title text-center">
						<span>CONNEXION</span>
					</li>
					{this.dispConnect()}
					{this.dispConnectedProfile()}
					{this.dispDisconnect()}
					{this.dispAdmin()}
					<br/>

					{this.dispStateloViesAd()}
					<br/>

					{/*this.dispPredatorTourAd()*/}
					{/*<br/>*/}

					<li className="nav-item"> <span>&nbsp;</span> </li>
					<li className="nav-item"> <span>&nbsp;</span> </li>

				</ul>
			</nav>
			</div>
		)
	}

	dispConnect() {
		//console.log('SIDEBAR: dispConnect')
		//console.log(this.state)
    if (!this.state.isAuthenticated) {
			return (
				<li className="nav-item">
					<a className="nav-link" onClick={this.connect.bind(this)}>
						<i className="icon-login"></i> Se connecter
					</a>
				</li>
			);
		}
	}

	dispConnectedProfile() {
		//console.log('SIDEBAR: dispConnectedProfile')
		//console.log(this.state)
		//console.log(this.state.profile.name)

    if (this.state.isAuthenticated) {
			return (
				<div>
				<li className="sidebar-special-connect"> Vous êtes connecté ... </li><br/>
				<li className="sidebar-special-item">
					<img className="img-sidebar-token" src={this.state.profile.picture}/>
					<span>&nbsp;&nbsp; {this.state.profile.name}</span>
				</li>
				<li className="nav-item">
					<Link to='/userAccount' className="nav-link">
						<i className="icon-user"></i> Votre Compte
					</Link>
				</li>
				</div>
			);
		}
	}

	dispDisconnect() {
    if (this.state.isAuthenticated) {
			return (
				<li className="nav-item">
					<Link to='/home' className="nav-link" onClick={this.disconnect.bind(this)}>
						<i className="icon-logout"></i> Se déconnecter
					</Link>
				</li>
			);
		}
	}

	dispAdmin() {
		// Validate admin access here !
    // console.log('Sidebar: dispAdmin');
    // console.log(this.state.isAuthenticated);
    // console.log(this.state.adminGlobalAccessLevel);
    if ((this.state.isAuthenticated) && (Users.AdminGlobalAccessOK(this.state.adminGlobalAccessLevel)) ) {
			return (
				<div>	
					<li className="nav-title text-center">
						<span>ADMIN</span>
					</li>
					<li className="nav-item">
						<Link to='/admsafe/home' className="nav-link">
						<i className="icon-wrench"></i> Admin
					</Link>
					</li>

					{(this.state.charterAdmin.indexOf('QVNEA-MASTER') !== -1) ?
						<li className="nav-item">
							<Link to='/qvnea/qvnea-books' className="nav-link">
							<i className="icon-wrench"></i> Qvnea Books
						</Link>
						</li>
					: null}

				</div>
			);
		}
	}

	dispStateloViesAd() {
		return (
			<div className="text-center">
				<a href="http://statelovies.com" target="_blank" className="text-center whiteLink">
					<img className="img-fluid" src="/img/statelovies.png" alt="statelo-tour" width="140"/>
				</a>
			</div>
		)
	}

	dispPredatorTourAd() {
		return (
			<div className="text-center">
				<Link to="/qvnea/predator-tour" className="text-center whiteLink">
					<img className="img-fluid" src="/img/predator-tour-02a.png" alt="predator-tour" width="170"/>
				</Link>
			</div>
		)
	}

}

export default Sidebar;
